import { gql } from '@apollo/client';

export default gql`
  mutation cancelBooking($bookingReference: String!) {
    cancelBooking(bookingReference: $bookingReference)
  }
`;
